/**
 * Resolve tenant (main_id) for customer portal OTP on Admin (no storefront).
 * Priority: URL param → ?tenant= query → env.
 */
export function getPortalTenantId(routeTenantId, searchParams) {
  if (routeTenantId != null && String(routeTenantId).trim()) {
    return String(routeTenantId).trim();
  }
  if (searchParams) {
    const q =
      searchParams.get("tenant") ||
      searchParams.get("main_id") ||
      searchParams.get("business");
    if (q && String(q).trim()) return String(q).trim();
  }
  const fromEnv = process.env.REACT_APP_PORTAL_TENANT_ID || "";
  return String(fromEnv).trim();
}

/** Shareable customer portal sign-in URL (Admin host or custom PUBLIC_PORTAL_BASE_URL). */
export function getCustomerPortalLoginUrl(tenantId) {
  const tid = tenantId != null ? String(tenantId).trim() : getPortalTenantId();
  const envBase = process.env.REACT_APP_CUSTOMER_PORTAL_URL;
  const base =
    envBase && String(envBase).trim()
      ? String(envBase).trim().replace(/\/+$/, "")
      : typeof window !== "undefined"
        ? window.location.origin
        : "";

  if (!base) return tid ? `/portal/login/${encodeURIComponent(tid)}` : "/portal/login";
  if (tid) return `${base}/portal/login/${encodeURIComponent(tid)}`;
  return `${base}/portal/login`;
}
